import React, { useState, useEffect } from 'react';
import {
  Clipboard,
  FlatList,
  Keyboard,
  Text,
  TextInput,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from 'react-native';
import Swipeout from 'react-native-swipeout';
import Icon from 'react-native-vector-icons/MaterialIcons';
import Styles from './styles';
import Config from './config';
import Hermes from './hermes';

const WordsURL = `${Config.Scheme}://${Config.Domain}/words`;

export default function WordsView({ route, navigation }) {
  var page = 0;
  var shadowList = [];
  var transaction = 0;
  var sorting = "";
  var [shadowSort, setShadowSort] = useState({word: "none", source: "none"});
  var [sortPriorities, setSortPriorities] = useState({word: 0, source: 0,});
  var [sortPriority, setSortPriority] = useState(1);
  var [list, setList] = useState([]);
  var [count, setCount] = useState(0);
  var [id, setID] = useState(0);
  var [search, setSearch] = useState("");
  var [refreshing, setRefreshing] = useState(false);
  const loadPage = async (transaction = 0) => {
    const _page = page;
    try {
      const url = `${WordsURL}?page=${_page}&pageSize=${Config.PageSize}&sorting=${encodeURIComponent(sorting)}&search=${search}`;
      const result = await Hermes.fetch(url, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });
      const words = result.words;
      if (words.length == 0) {
        if (shadowList.length == 0 && transaction == transaction) {
          shadowList.push({empty: true})
          setList(shadowList);
        }
        return;
      }
      if (transaction != 0 && transaction != transaction) {
        return;
      }
      if (words.length > 0) {
        page++;
        shadowList = shadowList.concat(words);
        setList(shadowList);
      }
    } catch(error) {
      Hermes.log(error);
    }
  };

  const updateCount = async () => {
    try {
      const result = await Hermes.fetch(`${WordsURL}_count`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });

      setCount(result.count);
    } catch(error) {
      Hermes.alert(error);
    }
  };

  useEffect(async () => {
    navigation.setOptions({ title: `Words` })
    await loadPage();
    await updateCount();
    setRefreshing(false);
  }, []);

  const refresh = async (transaction = 0) => {
    page = 0;
    shadowList = [];
    await loadPage(transaction);
    await updateCount();
  };

  const _refresh = async () => {
    await refresh();
    setRefreshing(false);
  };

  const add = async (content = "") => {
    try {
      if (content == "") {
        content = await Clipboard.getString();
        Clipboard.setString('');
      } else {
        await clearSearch();
      }
      navigation.navigate('EditWord', {id: 0, word: content.trim()}, null, 'edit_word')
    } catch (e) {
      Hermes.alert(e.message);
    }
  };

  const _delete = async (rowData) => {
    try {
      await Hermes.fetch(`${WordsURL}/${rowData.id}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "DELETE",
      });

      await refresh();
    } catch(error) {
      Hermes.alert(error);
    }
  };

  const _sort = async (column) => {
    let direction = "none";
    let priority = 0;
    if (shadowSort[column] == "none") {
      direction = "asc";
      priority = sortPriority;
      setSortPriority(sortPriority + 1);
    } else if (shadowSort[column] == "asc") {
      direction = "desc";
      priority = sortPriority;
      setSortPriority(sortPriority + 1);
    }

    shadowSort[column] = direction;
    sortPriorities[column] = priority;

    const sorted = Object.keys(sortPriorities)
      .map((key) => {return {column: key, priority: sortPriorities[key]};})
      .sort((a, b) => {return a.priority-b.priority;});
    sorting = "";
    sorted.forEach((value) => {
      if (value.priority > 0) {
        const column = value.column;
        sorting += column + "," + shadowSort[column] + ";";
      }
    });
    await refresh();
  };

  const getSortSymbol = (column) => {
    const symbols = {
      none: "",
      asc: "\u2191",
      desc: "\u2193",
    };
    return symbols[shadowSort[column]];
  };

  const _search = async (query) => {
    if (search == query) {
      return;
    }

    search = query;
    transaction++;
    setSearch(query);
    setList([]);
    await refresh(transaction);
  };

  const clearSearch = async () => {
    await search('');
    Keyboard.dismiss();
  };

  const renderHeader = () => {
    return (
      <View style={{paddingTop: 30}}>
        <View style={{flex: 1, flexBasis: 1, flexDirection: 'row',
          justifyContent: 'space-around', alignItems: 'center'}}>
          <TextInput
            autoFocus={true}
            style={Styles.input}
            onChangeText={_search}
            value={search}
            placeholder="Search"
            autoCapitalize='none'/>
          <TouchableOpacity style={{padding: 10}} onPress={clearSearch}>
            <Icon name={'close'} size={40}/>
          </TouchableOpacity>
        </View>
        <View style={Styles.heading}>
          <Text
            style={{flex: 2, fontSize: 16, fontWeight: 'bold'}}
            onPress={() => _sort('word')}>Word{getSortSymbol('word')}</Text>
          <Text
            style={{flex: 1, fontSize: 16, fontWeight: 'bold'}}
            onPress={() => _sort('source')}>Source{getSortSymbol('source')}</Text>
        </View>
        <TouchableHighlight onPress={() => add()}>
          <View style={{flex: 1, flexDirection: 'row', borderBottomWidth: 1,
            borderBottomColor: '#808080', justifyContent: 'flex-start', alignItems: 'center'}}>
            <Icon style={{paddingLeft: 10}} name={'add'} size={30}/>
            <Text style={{marginLeft: 20, fontSize: 16, fontWeight: 'bold'}}>Add Word ({count})</Text>
          </View>
        </TouchableHighlight>
      </View>
    );
  };

  const renderRow = ({item, index, separators}) => {
    if (item.empty) {
      return (
        <View>
          <View style={Styles.row}>
            <Text style={{fontSize: 16, fontWeight: 'bold'}}>No words found</Text>
          </View>
          <TouchableHighlight onPress={() => add(search)}>
            <View style={{flex: 1, flexDirection: 'row', borderBottomWidth: 1,
              borderBottomColor: '#808080', justifyContent: 'flex-start', alignItems: 'center'}}>
              <Icon style={{paddingLeft: 10}} name={'add'} size={30}/>
              <Text style={{marginLeft: 20, fontSize: 16, fontWeight: 'bold'}}>Add Word: {search}</Text>
            </View>
          </TouchableHighlight>
        </View>
      );
    }
    const wordnikProps = {
      id: item.id,
      word: item.word,
      //wordsView: this,
    }
    return (
      <Swipeout right={[
        {
          text: 'Delete',
          backgroundColor: 'red',
          onPress: () => _delete(item)
        },
      ]} left={[
        {
          text: 'Lookup',
          backgroundColor: 'green',
          onPress: () => navigation.navigate('Wordnik', wordnikProps, null, 'root_word')
        },
        {
          text: 'Say',
          backgroundColor: 'blue',
          onPress: () => window.speechSynthesis.speak(new SpeechSynthesisUtterance(item.word))
        },
      ]} backgroundColor={'#ffffff'} autoClose={true}>
        <TouchableHighlight onPress={() => navigation.navigate('EditWord', {id: item.id}, null, 'edit_word')}>
          <View style={Styles.row}>
            <View style={Styles.item}>
              <Text style={{flex: 2}}>{item.word}</Text>
              <Text style={{flex: 1}}>{item.source}</Text>
            </View>
            {item.definition != "" &&
              <View style={Styles.definition}>
                <Text>
                  {item.partOfSpeech != "" &&
                    <Text style={{fontWeight: 'bold', fontSize: 10}}>{item.partOfSpeech}: </Text>
                  }
                  <Text style={{fontSize: 10}}>{item.definition}</Text>
                </Text>
              </View>
            }
          </View>
        </TouchableHighlight>
      </Swipeout>
    );
  };

  return (
    <View key="key1" style={Styles.container}>
      <FlatList
        data={list}
        keyExtractor={(item) => {
          if (!item || !(item.id)) {
            return "";
          }
          return item.id.toString();
        }}
        onRefresh={_refresh}
        refreshing={refreshing}
        ListHeaderComponentStyle={{backgroundColor: 'white'}}
        ListHeaderComponent={renderHeader}
        stickyHeaderIndices={[0]}
        keyboardShouldPersistTaps='always'
        //enableEmptySections={true}
        onEndReached={async () => {
          await loadPage();
          await updateCount();
          setRefreshing(false);
        }}
        renderItem={renderRow}/>
    </View>
  );
}
